import { render, staticRenderFns } from "./TooltipBtn.vue?vue&type=template&id=3c70d790"
import script from "./TooltipBtn.vue?vue&type=script&lang=ts"
export * from "./TooltipBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports